(function() {
  var REGULAR_PRICE_CENTS = 2195;
  var autoSelected = true; // Oct 9 2026: Subscribe auto-select turned off so one-time purchase stays the default

  function formatMoney(cents) {
    return '$' + (Math.abs(cents) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getSellingPlanPrices() {
    var prices = {};
    try {
      var rules = window.SealSubs && window.SealSubs.getRuleConfig && window.SealSubs.getRuleConfig();
      if (rules) {
        rules.forEach(function(rule) {
          (rule.selling_plans || []).forEach(function(plan) {
            var adj = plan.price_adjustments && plan.price_adjustments[0];
            if (!adj) return;
            if (adj.value_type === 'price') {
              prices[plan.id] = REGULAR_PRICE_CENTS - adj.value;
            } else if (adj.value_type === 'percentage') {
              prices[plan.id] = Math.round(REGULAR_PRICE_CENTS * adj.value / 100);
            } else if (adj.value_type === 'fixed_amount') {
              prices[plan.id] = adj.value;
            }
          });
        });
      }
    } catch(e) {}
    return prices;
  }

  function getCurrentSavings() {
    var select = document.querySelector('select[name="subs_interval"]');
    if (!select) return 400;
    var prices = getSellingPlanPrices();
    return prices[select.value] || 400;
  }

  function autoSelectSubscribe() {
    if (autoSelected) return;
    var containers = document.querySelectorAll('.sls-option-container');
    if (containers.length < 2) return;
    var subscribeC = Array.from(containers).find(function(c) {
      return c.textContent.includes('Subscribe');
    });
    if (!subscribeC) return;
    // Only auto-select if subscribe is not already active
    if (!subscribeC.classList.contains('sls-active')) {
      subscribeC.click();
    }
    autoSelected = true;
  }

  function enhanceWidget() {
    var containers = document.querySelectorAll('.sls-option-container');
    containers.forEach(function(container) {
      if (!container.textContent.includes('Subscribe') && !container.classList.contains('sls-subscribe-highlighted')) return;

      if (!container.classList.contains('sls-subscribe-highlighted')) {
        container.classList.add('sls-subscribe-highlighted');
      }

      var savingsCents = getCurrentSavings();
      var savingsStr = formatMoney(savingsCents);
      var badgeText = 'Save ' + savingsStr;
      var descText = 'Save ' + savingsStr + ' per order by subscribing. Cancel anytime.';

      var badge = container.querySelector('.sls-savings-badge');
      if (badge && badge.textContent !== badgeText) {
        badge.textContent = badgeText;
      }

      var desc = container.querySelector('.sls-selling-plan-description-content');
      if (desc && desc.textContent.trim() !== descText) {
        desc.textContent = descText;
      }

      var moreInfo = container.querySelector('.sls-more-info-container');
      if (moreInfo) moreInfo.style.setProperty('display', 'none', 'important');
    });

    document.querySelectorAll('.sls-widget-branding, .sls-more-info-container').forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function attachSelectListener() {
    var select = document.querySelector('select[name="subs_interval"]');
    if (select && !select._scListenerAttached) {
      select.addEventListener('change', function() { setTimeout(enhanceWidget, 80); });
      select._scListenerAttached = true;
    }
  }

  var startTime = Date.now();
  var interval = setInterval(function() {
    autoSelectSubscribe();
    enhanceWidget();
    attachSelectListener();
    if (Date.now() - startTime > 120000) clearInterval(interval);
  }, 250);

  var observer = new MutationObserver(function() {
    autoSelectSubscribe();
    enhanceWidget();
    attachSelectListener();
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  enhanceWidget();
})();